<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2>{{ pageTitle }}</h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        v-safe-html="pageContent"
        class="text-justify"
        cols="12"
      />
    </v-row>
  </v-container>
</template>

<script>
export default {
  name      : 'PageContent',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    pageTitle: {
      type   : String,
      default: ''
    },

    pageContent: {
      type   : String,
      default: ''
    }
  },
  enums    : {},
  dataStore: {},
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}

</script>

<style scoped>
:deep(table) {
  width: 100%;
}

:deep(table), :deep(th), :deep(td) {
  border: 1px solid #000;
  border-collapse: collapse;
  padding: 2px;
}
</style>
